import { Steps as SharedSteps, Step } from '@components'

import { useTranslation } from 'react-i18next'

export const Steps = () => {
  const { t } = useTranslation()

  const steps: Step[] = [
    {
      number: 1,
      description: 'skat.submit_form.steps.approve_description',
      header: t('skat.submit_form.steps.approve_header'),
    },
    {
      number: 2,
      description: 'skat.submit_form.steps.proceed_description',
      header: t('skat.submit_form.steps.proceed_header'),
    },
  ]

  return <SharedSteps steps={steps} />
}
